import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import { useSidebar } from '@/core/hooks/useSidebar';
import type { NoteSummary } from '@/features/notes/public';

interface NotesPanelItemProps {
  note: NoteSummary;
}

export function NotesPanelItem({ note }: NotesPanelItemProps) {
  const { t } = useTranslation('layout');
  const { orgId } = useParams<{ orgId: string }>();
  const { pathname } = useLocation();
  const { closeMobile, isMobile } = useSidebar();

  const noteId = note.id ?? '';
  const isActive = pathname === `/${orgId}/notes/${noteId}`;

  return (
    <Link
      to={`/${orgId}/notes/${noteId}`}
      onClick={() => isMobile && closeMobile()}
      data-testid={`notes-sidebar-item-${noteId}`}
      className={cn(
        'flex flex-col gap-0.5 rounded-lg px-3 py-2 transition-colors',
        isActive
          ? 'bg-primary/10 text-primary'
          : 'text-muted-foreground hover:bg-muted hover:text-foreground',
      )}
    >
      <span
        className={cn(
          'truncate text-sm leading-none',
          isActive ? 'font-medium text-primary' : 'font-medium text-foreground',
        )}
      >
        {note.title || t('sidebar.notes.untitled')}
      </span>
      {note.preview && (
        <span className="truncate text-xs text-muted-foreground">{note.preview}</span>
      )}
    </Link>
  );
}
